/**
 * lucide-react 패키지가 제공하는 전체 아이콘 맵 (`icons` export)
 * @see https://lucide.dev/guide/packages/lucide-react
 */
import { icons } from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

export const lucideFullIconMap = icons as Record<string, LucideIcon>

/** 정렬된 표시용 이름 목록 (PascalCase 등) */
export const lucideFullIconNamesSorted: string[] = Object.keys(lucideFullIconMap).sort((a, b) =>
  a.localeCompare(b, 'en')
)
